// Header.js
import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class Header extends Component {
    render(){
        return (
           <div>
                <header id="navbar">
                    <nav className="navbar navbar-expand-lg navbar-fixed-top">
                        <div className="container row mx-auto">
                            <div className="col-auto p-0">
                                <div className="region region-nav-branding">
                                    <div id="block-intellisaving-branding" className="block block-system block-system-branding-block">
                                        <div className="navbar-brand d-flex align-items-center">  
                                          <a href='https://www.intellisaving.com' title="Home" rel="home" className="site-logo d-block">
                                            <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/logo_0.png'}
                                            alt="Home" /> 
                                            </a>
                                            <div> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 col-md-auto p-0 text-right">
                                <button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"> <span className="icon-bar"></span> <span className="icon-bar"></span> <span className="icon-bar"></span> </button>
                            </div>
                            <div className="collapse navbar-collapse col-12 col-md-auto p-0 justify-content-end" id="navbarSupportedContent">
                                <div className="region region-nav-main">
                                    <nav role="navigation" aria-labelledby="block-intellisaving-main-navigation-menu" id="block-intellisaving-main-navigation" className="block block-menu navigation menu--main">
                                        <h5 className="visually-hidden" id="block-intellisaving-main-navigation-menu">Main navigation</h5>
                                        <ul className="navbar-nav mr-auto header-menu">
                                            <li className="nav-item"> 
                                                <a href='https://www.intellisaving.com' className="nav-item nav-a is-active" data-drupal-a-system-path="&lt;front&gt;">Home</a>
                                            </li>
                                            <li className="nav-item"> 
                                                <a href='https://www.intellisaving.com/best-savings-rates' className="nav-item nav-a" data-drupal-a-system-path="node/1">Best Savings Rates</a>
                                            </li>
                                            <li className="nav-item"> 
                                                <a href='https://www.intellisaving.com/' className="nav-item nav-a" data-drupal-a-system-path="node/1">About</a>
                                            </li>
                                            <li className="nav-item"> 
                                                <a href='https://www.intellisaving.com/money-saving-tips' className="nav-item nav-a" data-drupal-a-system-path="node/1">Money Saving Tips</a>
                                            </li>
                                            <li className="nav-item"> 
                                                <a href="https://www.intellisaving.com/contact" className="nav-item nav-a" data-drupal-a-system-path="contact">Contact</a> 
                                            </li>
                                            <li className="nav-item"> 
                                                <a href="https://www.intellisaving.com/careers" className="nav-item nav-a" data-drupal-a-system-path="node/1">Careers</a> 
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </nav>
                </header>
            </div>
        )
    }
}